export default "__VITE_ASSET__fUwUaTj92Cg73JeOIXr4LA__";